import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';

function NotFoundPage() {
    const { t } = useI18n();
    return (
        <>
                                          <Helmet>
        <title>{t('nf.title')}</title>
        <meta name="description" content={t('masalar.pageDesc')} />
      </Helmet>
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <h1 className="text-6xl font-bold text-gray-800">404</h1>


            <p className="mt-4 text-xl text-gray-600"> {t('nf.heading')}</p>
            <p className="mt-2 text-gray-500">{t('nf.text')}</p>
            <Link to="/" className="mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
            {t('nf.backHome')}
            </Link>
           
        </div>
        </>
        
    );
}

export default NotFoundPage;


